
import {defineComponent, provide, reactive, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import FileList from './components/file-list.vue';
import PreviewCanvas from './components/preview-canvas.vue';
import FilterList from './components/filter-list.vue';
import DownloadForm from './components/download-form.vue';
import {useStore} from './store';
import {Toast, key as toastKey} from './toast';
import {APP_VERSION} from './init';

export default defineComponent({
  name: 'App',
  components: {
    FileList,
    PreviewCanvas,
    FilterList,
    DownloadForm,
  },
  setup() {
    const {t, availableLocales, locale} = useI18n({useScope: 'global'});
    const store = useStore();
    const toastList = reactive(new Map<symbol, Toast>());
    const showToast = (toast: Toast) => {
      const symbol = Symbol();
      toastList.set(symbol, toast);
      setTimeout(() => toastList.delete(symbol), toast.duration);
    };
    provide(toastKey, showToast);
    const visibleMobileFilePanel = ref<boolean>(false);
    const visibleMobileFilterPanel = ref<boolean>(false);
    return {
      t,
      availableLocales,
      store,
      locale,
      showToast,
      toastList,
      visibleMobileFilePanel,
      visibleMobileFilterPanel,
      APP_VERSION,
    };
  },
});
